<template>
  <v-app id="app" :dark="darkTheme">
    <v-main v-if="loading.happening">
      <v-container fill-height justify-center align-center>
        <v-progress-circular
          :size="300"
          :width="15"
          color="primary"
          :value="loading.percent"
        >
          {{ loading.text }}
        </v-progress-circular>
      </v-container>
    </v-main>
    <div v-else>
      <twilio-chat v-if="twilioChat" />
      <router-view />
    </div>
  </v-app>
</template>

<script>
import TwilioChat from "./components/TwilioChat";
import { mapState } from "vuex";
// import PusherHandler from "@/components/PusherHandler.vue";

export default {
  components: {
    TwilioChat
    // PusherHandler,
  },
  computed: {
    ...mapState({
      darkTheme: (state) => state.application.settings.darkTheme,
      loading: (state) => state.application.loading,
      twilioChat: (state) => state.application.twilioChat
    })
  },
  mounted() {
    this.$vuetify.theme.dark = this.darkTheme;
  }
};
</script>

<style>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0;
}

.twilioDrawer {
  width: 115.5rem;
  position: absolute;
  left: 21.45rem;
}

table thead th,
table tbody td {
  white-space: nowrap;
}
</style>
